<div 
    class="searchBox topSearch sideBarSearch"
>
    <input
        #box
        type="text" 
        class="searchTapTextArea" 
        [placeholder]="'HOME_SEARCH_INPUT_PLACEHOLDER' | translate"
        (keyup.enter)="onSearchEnter(box.value)" 
    >
    <a
        class="searchBackBtn"
    ><i class="icon icon-search2"></i> 
    </a> 
</div>